Vue.component('receivedPack', {
  template: templates.receivedPack,
  data() {
    return {
      model: {
        packs: [],
        pack: null,
        show: false,
        audio: null,
        packsImages: {
          '7367EAC0-D1FB-4C5D-8482-26EE1980D6EC': 'standard',
          'BC825D99-2015-44FB-B617-F8B796FB2369': 'standard',
          '4295010A-4755-4BEC-9E81-F7DDD11DEFD7': 'booster',
          '5BD8C208-E5B0-4F1B-AF16-D8DD2DCE39EB': 'ultra',
          '843BED60-D4DE-4DAB-8D94-C13F183953C1': 'legendary'
        }
      }
    }
  },
  mounted() {
    const c = this;
    
    c.model.audio = new Audio('../audio/award-01.mp3');
    c.getPacks();
  },
  methods: {
    getPacks() {
      const c = this;

      packService.getReceived()
        .then(function (response) {
          c.model.packs = response.data;
          c.showPacks();
        })
        .catch(function (error) {
          setTimeout(function() {
            c.getPacks();
          }, 5000);
        });
    },
    showPacks() {
      const c = this;

      if (c.model.packs.length) {
        c.showPack(c.model.packs[0]);
      } else {
        c.getPacks();
      }
    },
    showPack(pack) {
      const c = this;

      twitchAPI.getUsersById([{twitchId: pack.twitchId}], function(userData) {

        for (let d of userData) {

          c.model.pack = pack;

          c.model.pack.twitchDisplayName = d.display_name;
          c.model.pack.twitchProfileImage = d.profile_image_url
          c.model.pack.src = `https://sgtwoofy.com/images/${c.model.packsImages[pack.packId]}.png`;

          c.savePack(pack);

          setTimeout(function() {
            c.model.show = true;
            c.model.audio.play();
          }, 300);

          setTimeout(function() {
            c.model.show = false;
            setTimeout(function() {
              c.model.packs.shift();
              c.showPacks();
            }, 1000);
          }, 8000);
          
        }

      });

    },
    savePack(pack) {
      packService.saveReceived({id: pack.id});
    }
  }
});